<template lang="html">
    <v-dialog :value="show" persistent scrollable fullscreen transition="scale-transition">
        <v-card class="chart-modal">

            <v-toolbar color="secondary" dark tabs>
                  <v-toolbar-title v-text="stationName"></v-toolbar-title>
                  <v-spacer></v-spacer>

                    <v-btn icon @click.native="hide">
                        <v-icon>close</v-icon>
                    </v-btn>

                    <v-tabs
                    class="tab-switcher"
                    fixed
                    centered
                    color="secondary"
                    slot="extension"
                    v-model="activeTab">

                        <v-tab href="#seven-day-flow">
                            Seven Day Flow
                        </v-tab>
                        <v-tab href="#flow-duration-tool">
                            Flow Duration Tool
                        </v-tab>
                        <v-tab href="#monthly-mean-flow">
                            Monthly Mean Flow
                        </v-tab>
                        <v-tab href="#flow-metrics">
                            Flow Metrics
                        </v-tab>
                        <v-tab href="#stage">
                            Stage
                        </v-tab>

                    </v-tabs>

                </v-toolbar>

                <v-tabs-items v-model="activeTab">

                    <v-tab-item id="seven-day-flow" lazy>
                        <v-card flat>
                            <v-card-text>
                                <div
                                v-if="!checkChartData(this.stationData, 'seven_day_flow', this.checkStreamflowDataFields.seven_day_flow)"
                                class="no-data grey lighten-2 grey--text">
                                    <span>No data available</span>
                                </div>
                                <div v-else>
                                    <seven-day-flow-chart v-if="activeTab === 'seven-day-flow'" :key="stationId" class="chart-seven-day-flow" />
                                    <div class="data-note">Data may be from a live sensor and has not gone through QA, so may contain errors.</div>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item id="flow-duration-tool" lazy>
                        <v-card flat>
                            <v-card-text>
                                <div>
                                    <flow-duration-tool v-if="activeTab === 'flow-duration-tool'" :key="stationId" class="chart-flow-duration-tool" />
                                    <div class="data-note">Data may be from a live sensor and has not gone through QA, so may contain errors.</div>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item id="monthly-mean-flow" lazy>
                        <v-card flat>
                            <v-card-text>
                                <!-- don't mount until the component is showing and the tab is active -->
                                <monthly-mean-flow-table v-if="show && activeTab === 'monthly-mean-flow'" />
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item id="flow-metrics" lazy>
                        <v-card flat>
                            <v-card-text>
                                <!-- don't mount until the component is showing and the tab is active -->
                                <flow-metrics-table v-if="show && activeTab === 'flow-metrics'" />
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item id="stage" lazy>
                        <v-card flat>
                            <v-card-text>
                                <div v-if="!checkChartData(this.stationData, 'stage', this.checkStreamflowDataFields.stage)"
                                class="no-data grey lighten-2 grey--text">
                                    <span>No data available</span>
                                </div>
                                <div v-else>
                                    <stage-chart v-if="activeTab === 'stage'" :key="stationId" class="stage-flow" />
                                    <div class="data-note">Data may be from a live sensor and has not gone through QA, so may contain errors.</div>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                </v-tabs-items>

        </v-card>
    </v-dialog>
</template>

<script>
import * as actions from '@/constants/actions';
import SevenDayFlowChart from '@/components/charts/StreamflowSevenDayChart';
import StageChart from '@/components/charts/StreamflowStageChart';
import FlowDurationTool from '@/components/charts/FlowDurationTool';
import MonthlyMeanFlowTable from '@/components/charts/MonthlyMeanFlowTable';
import FlowMetricsTable from '@/components/charts/FlowMetricsTable';
import checkData from '@/mixins/checkQueryData';
import streamflowData from '@/mixins/streamflowData';

export default {
    name: 'chart-modal',
    components: {
        SevenDayFlowChart,
        MonthlyMeanFlowTable,
        StageChart,
        FlowDurationTool,
        FlowMetricsTable,
    },
    mixins: [
        checkData,
        streamflowData,
    ],
    computed: {
        show() {
            return this.$store.state.showChartModal;
        },
        activeTab: {
            get() {
                return this.$store.state.chartModalActiveTab;
            },
            set(val) {
                this.$store.dispatch(actions.SET_CHART_MODAL_TAB, val);
            },
        },
        station() {
            return this.$store.state.map.selectedStation;
        },
        stationData() {
            return this.queryData;
        },
        stationName() {
            if (this.stationData) {
                return this.stationData.name;
            }
            return '';
        },
        stationId() {
            if (this.station) {
                return this.station.id;
            }
            return '';
        },
    },
    methods: {
        hide() {
            this.$store.dispatch(actions.SHOW_CHART_MODAL, false);
        },
    },
};
</script>

<style scoped lang="scss">
.tab-switcher  {
    display: flex;
    flex-direction: column;
}

.tab-switcher-items {
    overflow-y: auto;
    flex: 1 1 100%;
}

.no-data {
    height: 15rem;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/ChartModalStreamflow.vue